import { Persona } from '@sdk/personaCollection/types/Persona';
import { User } from '@sdk/users/types/User';

import { GROUP_TYPE_ORDER } from './conversationMembers.consts';
import { ID, Member, MembersGroup } from './conversationMembers.types';

export const mapData = (personasDictionary: Record<ID, Persona>, memberIds: ID[]) => {
  const personas = Object.values(personasDictionary);
  const validGroups = personas.filter(
    (persona) => persona.type !== 'user' && memberIds.includes(persona.id)
  );
  const validUsers = personas.filter(
    (persona) => persona.type === 'user' && persona.isActive
  ) as User[];

  const directMembers: Member[] = [];
  const uniqueUserIds = new Set();

  const groups: MembersGroup[] = validGroups
    .map(
      (group) =>
        ({
          id: group.id,
          displayName: group.name,
          type: group.type,
          members: [],
        }) as MembersGroup
    )
    .sort((a, b) => GROUP_TYPE_ORDER[a.type] - GROUP_TYPE_ORDER[b.type]);

  validUsers.forEach((user) => {
    const member = {
      id: user.id,
      displayName: user.fullname,
      isMe: user.isMe ?? false,
    };

    if (memberIds.includes(member.id)) {
      directMembers.push(member);
      uniqueUserIds.add(member.id);
    }

    groups.forEach((group) => {
      if (user.allTypeGroupIds.includes(group.id)) {
        group.members.push(member);
        uniqueUserIds.add(member.id);
      }
    });
  });

  return {
    directMembers,
    groups,
    membersCount: uniqueUserIds.size,
  };
};
